import css from './authPage.module.css'
import TextInput from '../../../../shared/Inputs/TextInput'
import useAuthPage from './useAuthPage'
import NbmgButton from '../../../../shared/NbmgButton'
import FlyingRocketLayout from '../../../../shared/Layouts/FlyingRocketLayout'

const AuthPage = () => {
  const ctrl = useAuthPage()

  const renderInput = () => {
    if (ctrl.contactSubmitted) {
      return (
        <TextInput
          value={ctrl.confirmationCode}
          name="confirmationCode"
          onChange={ctrl.setConfirmationCode}
          inscription={`Код подтверждения - ${ctrl.contact}`}
          placeHolder="000000"
        />
      )
    }

    return (
      <TextInput
        value={ctrl.contact}
        name="contact"
        onChange={ctrl.handleContactChange}
        inscription="Email"
        placeHolder="example@scalartis.com"
      />
    )
  }

  return (
    <FlyingRocketLayout>
      <div className={css.container}>
        <h2 className={css.header}>АвторизА́ция</h2>
        {renderInput()}
        <div className={css.footer}>
          <NbmgButton
            onClick={ctrl.contactSubmitted ? ctrl.handleContactConfirm : ctrl.handleContactSubmit}
            loading={ctrl.loading}
            withHands={true}
          >
            {ctrl.contactSubmitted ? 'Войти' : 'Далее'}
          </NbmgButton>
        </div>
      </div>
    </FlyingRocketLayout>
  )
}

export default AuthPage
